export const NAME = 'question';



// WEBPACK FOOTER //
// ./src/question/constants.js